module.exports = __webpack_public_path__ + "img/gongsi.38774496.png";